import { render, staticRenderFns } from "./studio_follow.vue?vue&type=template&id=656acfb4&scoped=true&"
import script from "./studio_follow.vue?vue&type=script&lang=js&"
export * from "./studio_follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656acfb4",
  null
  
)

export default component.exports